import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  Injector,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CacheService } from 'ng2-cache';
import { Ng2CacheModule } from 'ng2-cache';
import { AppComponent } from './app.component';
import { AppConfig } from '../app/app.config';
import { LoginComponent } from '../app/menuItems/security/login.component';
import { AppRoutingModule } from './app-routing.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { CommonGratModule } from './common/common.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { MyHttpInterceptor } from './common/client/httpInterceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { PayDayLoginComponent } from './menuItems/security/payDayLogin.component';
import { SignUpComponent } from './menuItems/security/signUp.component';
import { DatePipe, DecimalPipe } from '@angular/common';
import { DateToUTCPipe, GsUIStatePipe, TimeFormatUSPipe } from './common/pipes/pipes';
import { RecaptchaModule } from 'ng-recaptcha';
import { UserManualDirective } from './common/directives/userManual';
import { ErrorInterceptor } from './common/client/error.interceptor';
import { NgOtpInputModule } from 'ng-otp-input';
import { BrinkerLoginComponent } from './menuItems/security/brinkerLogin.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export let AppInjector: Injector;
export let helpPath: string;

@NgModule({
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    Ng2CacheModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    CommonGratModule,
    NgxSpinnerModule,
    // SW is used only for static-asset cache + update-version notification
    // (see UpdateService). In local dev it just caches stale JS/CSS and can
    // serve back cached 504s — disable it everywhere except production builds.
    // main.ts already gated navigator.serviceWorker.register the same way.
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately',
    }),
    RecaptchaModule,
    DragDropModule,
    NgOtpInputModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    LoginComponent,
    PayDayLoginComponent,
    BrinkerLoginComponent,
    SignUpComponent,
    UserManualDirective,
  ],
  exports: [FormsModule, ReactiveFormsModule, UserManualDirective],
  providers: [
    HttpClient,
    AppConfig,
    CacheService,
    ConfirmationService,
    DatePipe,
    GsUIStatePipe,
    DecimalPipe,
    UserManualDirective,
    TimeFormatUSPipe,
    DateToUTCPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
}
